import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=8bffa936&scoped=true"
import script from "./customer-list.vue?vue&type=script&lang=js"
export * from "./customer-list.vue?vue&type=script&lang=js"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=8bffa936&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bffa936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bffa936')) {
      api.createRecord('8bffa936', component.options)
    } else {
      api.reload('8bffa936', component.options)
    }
    module.hot.accept("./customer-list.vue?vue&type=template&id=8bffa936&scoped=true", function () {
      api.rerender('8bffa936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/fee_rule/form/customer-list.vue"
export default component.exports